const { html } = window;

const links = (library) => `
<div class="Members-supportButtonsWrapper columns small-12 medium-8">
    ${!library.attributes.cardAcquisitionUrl && !library.attributes.branchUrl && !library.attributes.supportUrl && !library.attributes.supportEmail ? `
        <a target="_blank" rel="noreferrer" disabled
            class="button radius outline Members-supportButton u-allCaps">${html('noLinks')}</a>` : ''}
    ${library.attributes.cardAcquisitionUrl ? `
        <a tabindex="0" target="_blank" rel="noreferrer" href="${library.attributes.cardAcquisitionUrl}" 
            class="button radius outline Members-supportButton js-support-button u-allCaps js-get-card"
            aria-label="${html('getACardFor', {library: library.attributes.branchName})}">${html('getACard')}</a>
        ` : ''}
    ${library.attributes.branchUrl ? `
        <a tabindex="0" target="_blank" rel="noreferrer" href="${library.attributes.branchUrl}" 
            class="button radius outline js-support-button Members-supportButton u-allCaps"
            aria-label="${html('members.mainWebsiteFor', {library: library.attributes.branchName})}">${html('members.mainWebsite')}</a>
        ` : ''}
    ${library.attributes.supportUrl ? `
        <a tabindex="0" target="_blank" rel="noreferrer" href="${library.attributes.supportUrl}" 
            class="button radius outline js-support-button Members-supportButton u-allCaps"
            aria-label="${html('getSupportFor', {library: library.attributes.branchName})}">${html('getSupport')}</a>
        ` : ''}
    ${!library.attributes.supportUrl && library.attributes.supportEmail ? `
        <a tabindex="0" href="mailto:${library.attributes.supportEmail}" 
            class="button radius outline js-support-button email Members-supportButton u-allCaps"
            aria-label="${html('getSupportFor', {library: library.attributes.branchName})}">${html('getSupport')}</a>
        ` : ''}
</div>`;

export default ({ members }) => `
<div class="row">
    <div class="columns small-12 Members-completeListWrapper js-complete-list" data-hidden=true>
        ${members && members.map((library) =>
            `<div class="js-branch Members-branchContainer ${library.attributes.branchName.toLowerCase().replace(/ /g, '')} 
                ${library.attributes.childBranches && library.attributes.childBranches.length ? library.attributes.childBranches.map((child) => `${child.branchName.toLowerCase().replace(/ /g, '')}`).join(' ') : ''}">
                <hr class="Members-horizBreak"/>
                <div class="Members-flexWrapper">
                    <div class="columns small-12 medium-4 Members-branchWrapper ${!library.attributes.childBranches ? 'is-empty' : ''}">
                    ${library.attributes.childBranches && library.attributes.childBranches.length ?
                        `<a role="button" class="Members-parentBranch js-parentBranch js-toggle-children" tabindex="0" 
                            aria-expanded="false" aria-controls="child-branches-container-${library.attributes.branchId}" data-branchid="${library.attributes.branchId}">
                            ${library.attributes.branchName}
                            <i class="icon-forward-arrow Members-toggleChildren js-arrow js-branch-${library.attributes.branchId}" aria-hidden="true"></i>
                        </a>
                        <div id="child-branches-container-${library.attributes.branchId}" class="Members-childBranchesWrapper js-children-container js-${library.attributes.branchId} hideMe">
                            <ul class="Members-childBranches js-child-branches">
                                ${library.attributes.childBranches && library.attributes.childBranches.map((child) =>
                                    `<li class="Members-childBranch">${child.branchName}</li>`
                                ).join('')}
                            </ul>
                        </div>` :
                        `<span class="Members-parentBranch js-parentBranch">
                            ${library.attributes.branchName}
                        </span>`}
                    </div>
                    ${links(library)}
                </div>
            </div>`
        ).join('')}
    </div>
</div>
`;
